// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function CardSeparator(Props) {
  return React.createElement("div", {
              className: "c-card-separator"
            });
}

var make = CardSeparator;

export {
  make ,
  
}
/* react Not a pure module */
